<template>
  <footer id="footer" class="nuxt-footer">
    <!-- Download Section -->
    <div class="footer-download">
      <div class="footer-container">
        <div class="download-card">
          <div class="download-content">
            <div class="download-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                <line x1="12" y1="18" x2="12.01" y2="18"/>
              </svg>
            </div>
            <div>
              <h3 class="download-title">Unduh Yohom Sekarang</h3>
              <p class="download-desc">Tersedia untuk perangkat Android</p>
            </div>
          </div>
          <a href="#" class="download-btn">
            <img src="assets/img/download-ps.png" alt="Download di Play Store" class="playstore-img" />
          </a>
        </div>
      </div>
    </div>

    <!-- Main Footer -->
    <div class="footer-main">
      <div class="footer-container">
        <div class="footer-grid">
          <!-- Company Info -->
          <div class="footer-col footer-col--brand">
            <img src="assets/img/logos/logo.png" alt="Yohom" class="footer-logo" />
            <p class="footer-address">
              Tumpang Krasak<br />
              Kudus, Bae 59327<br />
              Indonesia
            </p>
            <div class="footer-contact-list">
              <div class="contact-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>+62 8189 9067 554</span>
              </div>
              <div class="contact-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <span>akunyohom@gmail.com</span>
              </div>
            </div>
          </div>

          <!-- Links Column -->
          <div class="footer-col">
            <h4 class="footer-col-title">Tautan Terkait</h4>
            <ul class="footer-links">
              <li><a href="/">Beranda</a></li>
              <li><a href="#">Tentang Kami</a></li>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Privacy Policy</a></li>
            </ul>
          </div>

          <!-- Menu Column -->
          <div class="footer-col">
            <h4 class="footer-col-title">Menu</h4>
            <ul class="footer-links">
              <li><a href="/blog">Blog</a></li>
              <li><a href="/gabungmitra">Gabung Mitra</a></li>
              <li><a href="/faq">FAQ</a></li>
            </ul>
          </div>

          <!-- Social Column -->
          <div class="footer-col">
            <h4 class="footer-col-title">Sosial Media</h4>
            <div class="social-links">
              <a href="#" class="social-btn" aria-label="Twitter">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="#" class="social-btn" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" class="social-btn" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a href="#" class="social-btn" aria-label="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-container">
        <div class="footer-bottom-inner">
          <p class="copyright">
            PT Yohom Indonesia Solution &copy; Copyright 2022
          </p>
          <p class="powered-by">
            Made with
            <svg width="14" height="14" viewBox="0 0 24 24" fill="#ef4444" stroke="none">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            in Indonesia
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700&display=swap');

.nuxt-footer {
  font-family: 'Public Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Download Section */
.footer-download {
  background: #f9fafb;
  padding: 48px 0;
  border-top: 1px solid #f3f4f6;
}

.download-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 40px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  gap: 24px;
}

.download-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.download-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%);
  color: #059669;
  flex-shrink: 0;
}

.download-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px;
  letter-spacing: -0.01em;
}

.download-desc {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
}

.download-btn {
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-2px);
}

.playstore-img {
  height: 48px;
  width: auto;
}

/* Main Footer */
.footer-main {
  background: #111827;
  padding: 56px 0 40px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 40px;
}

.footer-logo {
  height: 36px;
  width: auto;
  margin-bottom: 16px;
  filter: brightness(0) invert(1);
}

.footer-address {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.7;
  margin: 0 0 16px;
}

.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #9ca3af;
}

.contact-item svg {
  color: #6b7280;
  flex-shrink: 0;
}

.footer-col-title {
  font-size: 14px;
  font-weight: 700;
  color: #f9fafb;
  margin: 0 0 20px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-links a {
  font-size: 14px;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.15s ease;
}

.footer-links a:hover {
  color: #10b981;
}

/* Social Links */
.social-links {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  color: #9ca3af;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.social-btn:hover {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
  border-color: rgba(16, 185, 129, 0.3);
  transform: translateY(-2px);
}

/* Bottom Bar */
.footer-bottom {
  background: #0d1421;
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.copyright {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
}

.powered-by {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .download-card {
    flex-direction: column;
    text-align: center;
    padding: 28px 24px;
  }

  .download-content {
    flex-direction: column;
  }

  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }

  .footer-col--brand {
    grid-column: 1 / -1;
  }

  .footer-bottom-inner {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
}
</style>